import type { NotificationProvider } from '@refinedev/core'
import { toast } from 'sonner'

export const notificationProvider: NotificationProvider = {
  open({ type, message, description, key }) {
    const content = description ? `${message}\n${description}` : message
    const id = key as string | number | undefined

    if (type === 'success') toast.success(content, { id })
    else if (type === 'error') toast.error(content, { id })
    else toast(content, { id })
  },
  close(key) {
    toast.dismiss(key as string | number | undefined)
  },
}
